<template>
  <div class="download bg-white">
    <headerCom></headerCom>
    <div class="down-content">
      <el-tag v-if="this.$route.query.uid && hasUseQuery" closable @close="closeParams">UID:{{this.$route.query.uid}}</el-tag>
      <el-table border
                :data="tableData" ref="multipleTable"
                highlight-current-row
                header-row-class-name="header-row-class-name"
                style="width: 100%"
                empty-text="请选择搜索条件"
                :height="tableHeight">
        <!--
        <el-table-column
                type="selection" align="center"
                width="55">
        </el-table-column>
        -->
        <el-table-column fixed align="center"
                         prop="id" width="100"
                         label="ID">
          <template slot="header" slot-scope="scope">
            <el-input
                    v-model="query.userId"
                    size="mini" @change="keywordSearch"
                    placeholder="UID"/>
          </template>
          <template slot-scope="scope">
            <router-link :to="'/operate/activitys?uid='+scope.row.id">{{scope.row.id}}</router-link>
          </template>
        </el-table-column>
        <el-table-column fixed
                prop="userName" minWidth="140"
                label="用户名">
          <template slot="header" slot-scope="scope">
            <el-input
                    v-model="keyword"
                    size="mini" @change="keywordSearch"
                    placeholder="用户名"/>
          </template>
          <template slot-scope="scope">
            <router-link :to="'/operate/activitys?uid='+scope.row.id">{{scope.row.userName}}</router-link>
          </template>
        </el-table-column>
        <el-table-column align="center"
                         label="是否会员"
                         prop="vipType"
                         width="80">
          <template slot="header" slot-scope="scope">
            <el-select v-model="query.vipType" placeholder="版本"
                       class="table-header-select"
                       @change="keywordSearch">
              <el-option
                      key=""
                      label="全部版本"
                      value="">
              </el-option>
              <template v-for="(item,vipType) in VERSIONS">
                <el-option :label="item.versionName" :value="vipType" :key="vipType"></el-option>
              </template>
            </el-select>
          </template>
          <template slot-scope="scope">
            <div>
              {{VERSIONS[scope.row.vipType].versionName}}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center"
                         label="用户状态"
                         prop="status"
                         width="80">
          <template slot="header" slot-scope="scope">
            <el-select v-model="query.status" placeholder="用户状态"
                       class="table-header-select"
                       @change="keywordSearch">
              <el-option
                      key=""
                      label="用户状态"
                      value="">
              </el-option>
              <el-option
                      key="0"
                      label="正常"
                      value="0">
              </el-option>
              <el-option
                      key="1"
                      label="封禁"
                      value="1">
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <el-switch @change="setUserStatus($event,scope.row)"
                    v-model="scope.row.status==0"
                    active-color="#13ce66"
                    inactive-color="#cccccc">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center"
                         label="注册时间"
                         prop="gmtCreated"
                         width="100">
          <template slot-scope="scope">
            {{unixtoTime(scope.row.gmtCreated,'YYYY/MM/DD')}}
          </template>
        </el-table-column>
        <el-table-column align="center"
                         label="头像"
                         prop="gmtCreated"
                         width="60">
          <template slot-scope="scope">
            <img :src="scope.row.avatar" class="avatar"/>
          </template>
        </el-table-column>

        <el-table-column align="center"
                         label="手机号"
                         prop="mobile"
                         width="120">
        </el-table-column>
        <el-table-column align="center"
                         label="微信号"
                         prop="wechat"
                         width="120">
        </el-table-column>
        <el-table-column align="center"
                         label="邮箱"
                         prop="email"
                         width="140">
        </el-table-column>
        <el-table-column align="center"
                         label="QQ"
                         prop="qq"
                         width="100">
        </el-table-column>
        <el-table-column width="140"
                         prop="mobile"
                         label="到期时间">
          <template slot-scope="scope">
            <div v-if="scope.row.vipType>0"
                 style="cursor: pointer">
              {{unixtoTime(scope.row.startTime,'YYYY/MM/DD HH:II')}}~{{unixtoTime(scope.row.endTime,'YYYY/MM/DD HH:II')}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
                fixed="right"  align="center"
                label="操作"
                width="60">
          <template slot-scope="scope">
            <el-dropdown @command="optionCommand($event,scope.row)">
              <span class="el-dropdown-link">
                  <i class="el-icon-view"></i>
                </span>
              <el-dropdown-menu slot="dropdown">
                <!--
                <el-dropdown-item command="tpl">开通海报</el-dropdown-item>
                -->
                <el-dropdown-item>
                  <a :href="buyVipUrl(scope.row.id)" target="_blank">升级版本</a>
                </el-dropdown-item>
                <el-dropdown-item command="">
                  <addDialog ref="addDialog"
                             :userId="scope.row.id">下载额度</addDialog>
                </el-dropdown-item>
                <el-dropdown-item command="">
                  <certification ref="certification"
                             :userId="scope.row.id">账号认证</certification>
                </el-dropdown-item>
                <el-dropdown-item v-if="scope.row.vipType>0" command="closeVer">关闭版本</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </template>
        </el-table-column>
      </el-table>

    </div>
    <div class="members-page" v-if="total>0">
      <el-pagination background
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="pageIndex"
                     :page-sizes="[20, 30, 50, 100]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </div>
    <userType ref="userType" @event="getnewlist"></userType>
    <el-dialog title="开通海报" class="fotoo" :visible.sync="dialogFormVisible">
      <div class="tips">{{form.userName||form.id}} / {{form.mobile}}</div>
      <div class="flex-vc" style="padding: 40px">
        <el-form :model="form">
          <el-form-item label="活动ID" label-width="60">
            <el-input v-model="form.activityId" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="openPosters">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import headerCom from '../components/header.vue'
  import App from '../util/comfun'
  import userType from './components/userType.vue'
  import addDialog from './components/traffic/addDialog'
  import certification from './components/certification/update'
  export default {
    //name: 'activitys',
    data () {
      return {
        minHeight:window.innerHeight-82,
        tableHeight:window.innerHeight-150,
        tableData: [],
        pageIndex:1,
        pageSize:20,
        unixtoTime:App.unixtoTime,
        keyword:'',
        total:0,
        query:{
          isVip:'',
          status:'',
        },

        datePicker:['',''],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '清除日期',
            onClick(picker) {
              picker.$emit('pick', ['','']);
            }
          }]
        },

        dialogFormVisible:false,
        form:{},
        hasUseQuery:true,
        VERSIONS:{},
      }
    },
    components:{
      headerCom,
      userType,
      addDialog,
      certification,
    },
    methods:{
      handleSizeChange(pageSize){
        this.pageSize=pageSize
        this.getnewlist()
      },
      handleCurrentChange(pageIndex){
        this.pageIndex=pageIndex
        this.getnewlist()
      },
      getnewlist(){
        let params = {
          "pageIndex": this.pageIndex,
          "pageSize": this.pageSize,
        }
        if(this.keyword){
          params.userName=this.keyword
        }
        Object.keys(this.query).forEach(key=>{
          if(this.query[key]!==''){
            params[key]=this.query[key]
          }
        })

        if(this.datePicker[0]){
          params.startTime=this.datePicker[0]+' 00:00:00'
          params.endTime=this.datePicker[1]+' 23:59:59'
        }
        if(this.hasUseQuery){
          if(this.$route.query.uid){
            params.userId=this.$route.query.uid
          }
        }
        this.params=params
        let loading=this.$loading({text:'loading...',target: '.content',})
        App.demand('/admin/user/queryUserList','POST',params).then(json=>{
          setTimeout(()=>{loading.close();},0)
          if(json.code==200) {
            json.data=json.data||{userTotal:0,userList:[]}
            this.tableData = json.data.userList||[];
            this.total=json.data.userTotal;
            if(this.total<1){
              this.$message({
                showClose: true,
                message: "暂无数据"
              });
            }
          }else{
            this.imgCount=0
            this.worksCount=0
            this.browse=0
            this.likenum=0
            this.commentCount=0
            this.tableData=[];
            this.allselect=false;
            this.total=0;
            this.$message({
              showClose: true,
              message: json.message
            });
          }
        })
      },
      keywordSearch(e){
        this.pageIndex=1
        this.getnewlist();
      },
      setUserVipType(stat,row){
        console.log(stat,row)
        if(stat) {//开启
          this.$refs.userType.show(row)
        }else{
          if(row.vipType<1) return;
          this.$confirm(row.userName+' 将被你关闭版本变为免费版,确定吗?', {
            confirmButtonText: '确定关闭',
            cancelButtonText: '取消',
            showClose:false,
            type: 'warning'
          }).then(res=>{
            App.demand('/admin/user/openMember','POST',{
              "paymentMethod": 99,
              "userId": row.id,
              "openVip": 0
            }).then(res=>{
              this.getnewlist();
            })
          })
        }
      },
      setUserStatus(stat,row){
        console.log(stat,row)
        App.demand('/admin/user/banUser','GET',{userId:row.id,status:stat?0:1}).then((res)=>{
          if(res.code!=200) return this.$message({
            showClose: true,
            message: res.message
          });
          this.getnewlist();
        })
      },
      optionCommand(command,row){
        //console.log(arguments)
        switch (command){
          case 'tpl':
            this.dialogFormVisible=true
            this.form=row
            break;
          case 'vip':
            this.setUserVipType(true,row)
            break;
          case 'closeVer':
            this.setUserVipType(false,row)
            break;
        }
      },
      openPosters(){
        if(!this.form.activityId) return;
        this.dialogFormVisible=false
        App.demand('/admin/openPosters','GET',{
          activityId:this.form.activityId,
          userId:this.form.id,
        }).then(res=>{
          this.$message('操作成功')
        })
      },
      closeParams(){
        this.hasUseQuery=false
      },
      buyVipUrl(uid){
        return App.buyVipUrl(uid)
      },
    },
    mounted(){
      Object.keys(this.$route.query).length>0?this.getnewlist():''
      setTimeout(()=>{
        this.VERSIONS=wxlite.VERSIONS
      },800)
    },

  }
</script>

<style>
  .down-content{
    widdiv: 100%;
    position: relative;
    padding:0;
  }
  .table-header{
    background: #FAFAFA;
  }
  .tr{
    height: 40px;
    line-height: 1.4;
    overflow: hidden;
  }
  .td{
    width: 60px;
    min-height: 40px;
    text-align: center;
    padding:10px 5px;
    box-sizing: border-box;
    border-right: 1px solid #E0E0E0;
  }
  .bg-light-gray{
    background: #EEF2F2;
  }
  .table-total{
    width:100%;
    height: 50px;
    padding:0 10px;
    box-sizing: border-box;
  }
  .draft-total-data>div{
    margin-left: 20px;
    color: #999;
  }
  .draft-total-data>div:first-child{
    margin-left: 10px;
  }
  .draft-total-data .font-size14{
    color: #353535;
  }
  .down-content{
    width: 100%;
    padding-left:15px;
    box-sizing: border-box;
  }
  /* .draft-title{
    height: 50px;
    line-height: 50px;
    margin-right: 10px;
  } */
  .table{
    width: 100%;
    border-top: 1px solid #E0E0E0;
    box-sizing: border-box;
    min-height: 540px;
    border-collapse: collapse;
  }
  .td:first-child{
    border-left: 1px solid #E0E0E0;
  }
  .checkbox {
    width: 16px;
    height: 16px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    cursor: pointer;
    display: inline-block;
  }
  .members-page{
    padding: 10px 0 10px 10px ;
  }
  .work-img{
    width:20px;
    height:20px;
    display: inline-block;
  }
  .td a{

  }
  .td a:hover{
    color: #27C4A2;
  }
  .pdf-mask{
    position: fixed;
    left:0;
    right:0;
    top:0;
    bottom:0;
    z-index:9999;
    background: rgba(0,0,0,.8);
  }
  .pdf-cover{
    width: 800px;
    position: fixed;
    left:0;
    right:0;
    top:0;
    bottom:0;
    margin: 0 auto;
    z-index:10000;
    overflow: scroll;
    box-sizing: border-box;
  }
  .detail-unit-list {
    padding-top: 18px;
  }
  .detail-unit-single {
    margin-right: 30px;
    margin-bottom: 10px;
    line-height: 20px;
    padding: 5px 0;
    cursor: pointer;
    font-weight: 500;
  }
  .unit-green-font {
    border-bottom: 1px solid #3dc4a7;
  }
  .el-icon-arrow-up:before {
    content: "\E6E1";
    position: relative;
    top: -6px;
  }
  .down-content .el-input__inner{
    height: 30px!important;
    line-height: 30px!important;
  }
  .el-date-editor--datetimerange.el-input__inner {
    width: 356px;
  }
  .el-date-editor .el-icon-time{
    line-height: 22px;
  }
  .el-date-editor .el-range-separator{
    line-height: 22px;
  }
  .search{
    height: 36px;
    border-radius: 5px;
    background: #F2F2F3;
    margin-right: 20px;
  }
  .search-input{
    width: 100px;
    height: 100%;
    outline: none;
    transition: width ease .3s;
    background: transparent;
    padding: 0 5px;
    border: 0;
    box-sizing: border-box;
    line-height: 36px;
    font-size: 14px;
    margin-right: 5px;
  }
  .search-button{
    padding: 0 10px;
    height: 100%;
  }
  .search-button img{
    width: 15px;
    height: 16px;
  }
  .header-row-class-name .cell{
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Light;
    font-weight: 300;
    color: #999999;
    line-height: 17px;
  }
  .pfotoo-el-date-picker.el-date-editor--daterange.el-input__inner {
    width: 79px;
    flex-direction:column;
    padding: 0;
  }
  .pfotoo-el-date-picker .el-range__icon{
    display: none;
  }
  .pfotoo-el-date-picker .el-range-separator{
    display: none;
  }
  .pfotoo-el-date-picker .el-range-input{
    width: 99%;
  }
  .avatar{
    width: 21px;
    height: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/members.vue